import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useRequiredFields from "../../../../hooks/useRequiredFields";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { ChartOfAccountStyles } from "../Chart-Of-Account/ChartOfAccountShared";
import SubCategoryForm from "./SubCategoryForm";

const today = () => new Date().toLocaleDateString("en-CA");

const Create = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({ effective_date: today() });
  const [chartOfAccount, setChartOfAccount] = useState([]);
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const { checkRequiredFields } = useRequiredFields();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await Http.get("/chart-of-account-code-2");
        setChartOfAccount(res.data || []);
      } catch (e) {
        console.error("Fetch error:", e);
        setError({
          load: ["Could not load the form data. Please refresh and try again."],
        });
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const accountHandleChange = (selectedOption) => {
    setInputs((values) => ({
      ...values,
      acc_chart_of_account_id: selectedOption ? selectedOption.value : "",
    }));
  };

  const displayError = (fieldName) =>
    error && error[fieldName] ? (
      <div className="text-danger small mg-t-4">{error[fieldName]}</div>
    ) : null;

  const selectedAccount =
    chartOfAccount.find(
      (option) =>
        String(option.value) === String(inputs.acc_chart_of_account_id),
    ) || null;

  const formSubmit = () => {
    if (saving) {
      return;
    }

    // Highlights empty required inputs; the server does the actual validation.
    checkRequiredFields();
    setSaving(true);
    Http.post("/sub-category", inputs)
      .then((res) => {
        navigate("/sub-category", {
          state: { message: res.data.message, type: "success" },
        });
      })
      .catch((e) => {
        setSaving(false);
        setError(
          e.response?.data?.errors || {
            general: [
              e.response?.data?.message ||
                "Could not save the sub category. Please try again.",
            ],
          },
        );
      });
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <div className="am-mainpanel">
        <ChartOfAccountStyles />
        <div className="am-pagetitle">
          <div>
            <h5 className="am-title mb-1">Create Sub Category</h5>
            <p className="text-muted mb-0 tx-12">
              Track balances per staff, supplier, distributor or custom party
              under an account
            </p>
          </div>
          <Link to="/sub-category" className="btn btn-outline-secondary">
            <i className="fa fa-arrow-left mg-r-6"></i>Back to List
          </Link>
        </div>

        <div className="am-pagebody">
          <div className="row">
            <div className="col-lg">
              <FormValidation error={error} />
            </div>
          </div>

          {loading ? (
            <div className="coa-panel">
              <div className="coa-empty">
                <ProgressSpinner
                  style={{ width: "42px", height: "42px" }}
                  strokeWidth="6"
                />
              </div>
            </div>
          ) : (
            <SubCategoryForm
              inputs={inputs}
              chartOfAccount={chartOfAccount}
              selectedAccount={selectedAccount}
              onChange={handleChange}
              onAccountChange={accountHandleChange}
              onSubmit={formSubmit}
              displayError={displayError}
              saving={saving}
              submitLabel="Create Sub Category"
              savingLabel="Saving..."
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Create;
